@if (budget$ | async; as budget) {
<div class="summary-container">
  <mat-card class="summary-card">
    <div class="budget-header-top-row">
      <div class="budget-header-left">
        <div class="budget-nav-pill">
          <button mat-icon-button
                  type="button"
                  [disabled]="!hasPreviousBudget"
                  (click)="goToPreviousBudget()"
                  [matTooltip]="hasPreviousBudget ? 'Previous budget in filtered list' : 'First budget in list'"
                  class="budget-nav-btn">
            <mat-icon>chevron_left</mat-icon>
          </button>
          @if (budgetNavPositionText) {
            <span class="budget-nav-counter">{{ budgetNavPositionText }}</span>
          }
          <button mat-icon-button
                  type="button"
                  [disabled]="!hasNextBudget"
                  (click)="goToNextBudget()"
                  [matTooltip]="hasNextBudget ? 'Next budget in filtered list' : 'Last budget in list'"
                  class="budget-nav-btn">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
        <a [routerLink]="['/budget',budget.id]" class="budget-title-link">
          @if (budget.project) {
            <span>Project {{ budget.project.projectNr }}</span>
          } @else {
            <span>Budget {{ budget.budgetNr }}</span>
          }
        </a>
        @if (budget.company) {
          <span class="company-name">&nbsp;{{ budget.budgetName }}&nbsp;<small>({{ budget.company?.companyName }})</small></span>
        }
      </div>

      <a mat-raised-button color="primary" [routerLink]="['/budget']" class="back-to-list-btn">
        <mat-icon>arrow_back</mat-icon>
        <span i18n>Budget list</span>
      </a>
    </div>
    <mat-card-content>
      <ul class="summary-meta">
        <li><strong>Status:</strong> {{ budget.status }}</li>
        <li><strong>Budget Creation Date:</strong> {{ budget.creation | timestamp | date }}</li>
        @if (budget.project) {
        <li><strong>Project Delivery Date (Scheduled):</strong>
          {{ budget.project.deliveryDate | timestamp | date }}</li>
        }
        @if (budget.project) {
        <li><strong>Project Archived Date:</strong>
          {{ budget.archivedDate | timestamp | date }}</li>
        }
      </ul>
      <div class="summary-details">
        @if (budget.project) {
        <div class="detail-item">
          <span class="detail-label">Project Manager:</span>
          <span class="detail-value">{{ budget.project?.projectManager?.displayName }}</span>
        </div>
        }
        <div class="detail-item">
          <span class="detail-label">Budget Author:</span>
          <span class="detail-value">{{ budget.assignee?.displayName }}</span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  @if (summaryBalance$ | async; as summary) {
  <mat-card class="balance-card">
    <mat-card-content>
      @if (budgetId && budget.version === 'v1') {
      <app-summary-balance-v1 [budget]="budget" [summary]="summary" [budgetId]="budgetId">
      </app-summary-balance-v1>
      }
      @if (budgetId && budget.version === 'v2') {
      <app-summary-balance-v2 [budget]="budget" [summary]="summary" [budgetId]="budgetId">
      </app-summary-balance-v2>
      }
    </mat-card-content>
  </mat-card>
  } @else {
  <mat-card class="loading-card">
    <mat-card-title>
      Loading summary...
    </mat-card-title>
  </mat-card>
  }

  <div class="tables-container">
    @if (budgetId) {
    <app-activity-balance-table [budgetId]="budgetId"></app-activity-balance-table>
    }

    @if (budgetId) {
    <app-materials-balance-table [budgetId]="budgetId"></app-materials-balance-table>
    }
  </div>
</div>
} @else {
<mat-card class="loading-card">
  <mat-card-title>
    Loading budget...
  </mat-card-title>
</mat-card>
}
